import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ErrorDetails, MagiisAccessCarrierProfileDTO } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class GetMagiisAccessCarrierProfile extends IRequestCommand<
  IGetMagiisAccessCarrierProfileResponse,
  ErrorDetails,
  IGetMagiisAccessCarrierProfileParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;

  override setParameters(parameters: IGetMagiisAccessCarrierProfileParameters) {
    this.urlSections.push('magiisaccess');
    this.urlSections.push(`carrierprofile`);
    this.urlSections.push(String(parameters.carrierProfileId));
    this.composeUrl();
  }
}

export interface IGetMagiisAccessCarrierProfileParameters extends ICommandParameters{
  carrierProfileId: number;
}

export type IGetMagiisAccessCarrierProfileResponse = MagiisAccessCarrierProfileDTO;
